// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__6RLKP","signatureButtonsRight":"ModalSign_signatureButtonsRight__NsZ_o"};